var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotificationBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20832901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.3147 14.0483C5.45297 15.1587 6.42072 15.9998 7.59593 15.9998C8.77102 15.9998 9.73888 15.1419 9.87717 14.0483C9.20318 14.1156 8.44279 14.1493 7.59593 14.1493C6.74907 14.1493 6.00602 14.1157 5.3147 14.0483Z",
    fill: "#5D5CF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8859 10.4807L12.6935 8.05815C12.4861 7.63758 12.3825 7.20021 12.3825 6.7292V5.83759C12.3825 3.75152 10.9308 2.00197 8.96071 1.48046V1.34586C8.96071 0.605624 8.33858 0 7.57815 0C6.81773 0 6.19559 0.605624 6.19559 1.34586V1.48046C4.22549 2.00194 2.77384 3.75161 2.77384 5.83759V6.7292C2.77384 7.18345 2.67016 7.63758 2.46283 8.05815L1.27037 10.4807C1.01119 11.0191 1.25313 11.6752 1.82344 11.9274C2.79118 12.348 4.58856 12.8358 7.57822 12.8358C10.5679 12.8358 12.3479 12.3311 13.333 11.9274C13.9204 11.675 14.1624 11.019 13.8858 10.4807H13.8859Z",
    fill: "#5D5CF5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification-bell.9553cc48.svg";
export { ForwardRef as ReactComponent };